import type { NodeRenderer } from "@tento-ui/brand/page-engine.types";
import {
  ComparisonSection,
  CtaSection,
  FaqSection,
  FeatureSection,
  HeroSection,
  IntegrationsSection,
  PricingSection,
  SocialProofSection,
} from "@tento-ui/brand/@generated/models";

import type { PageEngineNodeProps } from "./to-props";

export const landingHeroRenderer = landingRenderer((sections, props) => (
  sections.hero.make(HeroSection.parse(props.node.props))
));

export const landingFeatureGridRenderer = landingRenderer((sections, props) => (
  sections.features.make(FeatureSection.parse(props.node.props))
));

export const landingSocialProofRenderer = landingRenderer((sections, props) => (
  sections.socialProof.make(SocialProofSection.parse(props.node.props))
));

export const landingIntegrationsRenderer = landingRenderer((sections, props) => (
  sections.integrations.make(IntegrationsSection.parse(props.node.props))
));

export const landingComparisonRenderer = landingRenderer((sections, props) => (
  sections.comparison.make(ComparisonSection.parse(props.node.props))
));

export const landingPricingRenderer = landingRenderer((sections, props) => (
  sections.pricing.make(PricingSection.parse(props.node.props))
));

export const landingFaqRenderer = landingRenderer((sections, props) => (
  sections.faq.make(FaqSection.parse(props.node.props))
));

export const landingCtaRenderer = landingRenderer((sections, props) => (
  sections.cta.make(CtaSection.parse(props.node.props))
));

function landingRenderer(
  make: (
    sections: NonNullable<PageEngineNodeProps["context"]["landing"]>,
    props: PageEngineNodeProps,
  ) => HTMLElement,
): NodeRenderer<PageEngineNodeProps> {
  return {
    make(props: PageEngineNodeProps): HTMLElement {
      const sections = props.context.landing;
      if (!sections) return document.createElement("div");
      return make(sections, props);
    },
    bind(
      _element: HTMLElement,
      props: PageEngineNodeProps,
    ): HTMLElement {
      const sections = props.context.landing;
      if (!sections) return document.createElement("div");
      return make(sections, props);
    },
    skeleton: null,
  };
}
